import patient from "../features/Patient/PatientSlice";
import GlobalSpinner from "../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
const rootReducer = { patient, GlobalSpinner };

export default rootReducer;
